import { Upload } from "antd";
import React, { useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { processPatientProfile, selectPatient, setGlobalLoading, setPatientSnapshotData } from "../../../store/actions";
import ToastMessage from "../../components/Toast";

const ImportPatientProfile = ({ handleContinue, ...restProps }) => {
  const [file, setFile] = useState(null);
  const [fileList, setFileList] = useState([]);
  const [isToast, setIsToast] = useState(false);
  const [toastType, setToastType] = useState("success");
  const [toastMsg, setToastMsg] = useState("");
  const dispatch = useDispatch();

  const resource = useSelector((state) => state.patientSnapshot.resource);

  const uploadProps = useMemo(() => {
    return {
      onRemove: (file) => {
        const index = fileList.indexOf(file);
        const newFileList = fileList.slice();
        newFileList.splice(index, 1);
        setFileList(newFileList);
        setFile(null);
      },
      beforeUpload: (file) => {
        const allowedTypes = ["application/pdf", "image/png", "image/jpeg", "image/jpg"];
        if (allowedTypes.includes(file.type)) {
          setFile(file);
          setFileList([file]);
          return false;
        } else {
          alert("Please choose a PDF or image file (PNG, JPG, JPEG).");
          return true;
        }
      },
      fileList,
    };
  }, [fileList]);

  const handleUpload = async () => {
    if (!file || !resource?.id) return;

    const formData = new FormData();
    formData.append("file", file);

    dispatch(setGlobalLoading(true));

    try {
      const result = await dispatch(processPatientProfile(resource.id, formData));

      if (result) {
        // Reload the patient data
        const updatedPatient = await dispatch(selectPatient(resource.id));
        if (updatedPatient) {
          await dispatch(setPatientSnapshotData("resource", updatedPatient));
        }

        setToastType("success");
        setToastMsg("Patient profile imported successfully!");
        setIsToast(true);
        setFile(null);
        setFileList([]);

        setTimeout(() => {
          setIsToast(false);
        }, 3000);
      }
    } catch (error) {
      setToastType("failed");
      setToastMsg("Failed to import patient profile. Please try again.");
      setIsToast(true);

      setTimeout(() => {
        setIsToast(false);
      }, 3000);
    } finally {
      dispatch(setGlobalLoading(false));
    }
  };

  return (
    <div className="resourceContent pr-7px" style={{ position: "relative" }}>
      {isToast && <ToastMessage type="Import" msg={toastMsg} status={toastType} />}

      <div
        className="resourceInfo d-flex"
        style={{
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ width: "100%", marginTop: 10 }}>
          <div style={{ display: "flex", justifyContent: "flex-end", marginRight: -5 }}>
            <Upload {...uploadProps} className="text-right">
              <button className="common-btn outlined-btn">Choose File</button>
            </Upload>
            <button
              className="common-btn blue-btn"
              style={{
                marginLeft: "0.5rem",
              }}
              onClick={handleUpload}
              disabled={!file}
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImportPatientProfile;
